module.exports = __webpack_public_path__ + "static/media/label-google-play.1b19c791.svg";